import flatpickr from 'flatpickr'
import ConfirmDatePlugin from 'flatpickr/dist/plugins/confirmDate/confirmDate'

const prebookingDesktop = ($el) => {
    if (typeof $el !== 'undefined' && $el != null) {
        const tabButtons = [...$el.querySelectorAll('.js-pb-tab-btn')]
        const tabPanels = [...$el.querySelectorAll('.js-pb-tab-panel')]
        const allLocationInputs = [...$el.querySelectorAll('.js-pb-locations-input')]
        // const datePickerInputs = [...$el.querySelectorAll('.js-pb-datepicker')]
        const datePickerPrebookEntry = $el.querySelector('#entry-date')
        const datePickerPrebookExit = $el.querySelector('#exit-date')
        const datePickerSeasonTicket = $el.querySelector('#season-ticket-date')

        const isActiveClass = 'is-active'

        /**
         * Setup current tab panel so we can use it across the prebooking system functions
         */
        let current = {
            tabPanel: $el.querySelector('.js-pb-tab-panel.is-active'),
        }
        /**
         * Set the first
         */
        let currentLocationsSelect = current.tabPanel.querySelector('.js-pb-locations-input')
        let isCurrentLocationsSelectOpen = false

        /**
         * Loop through all inputs and bind click event
         */
        allLocationInputs.forEach(locationInput => {
            locationInput.addEventListener("click", (e) => {
                currentLocationsSelect = current.tabPanel.querySelector('.js-pb-locations-input')
                selectACarParkDropdown(e.target)
            })
        })

        /**
         * Tab switcher
         */
        tabButtons.forEach((tabBtn) => {
            tabBtn.addEventListener('click', (e) => {
                resetLocationsDropdown()

                /**
                 * Only do something if we've clicked an inactive button
                 * Remove active class from active one and set aria selected to false
                 */
                if (!e.target.classList.contains(isActiveClass)) {
                    tabButtons.forEach((tabBtn) => {
                        tabBtn.classList.remove(isActiveClass)
                        tabBtn.setAttribute('aria-selected', false)
                    })

                    /**
                     * Add active class to the target button and set aria selected to true
                     */
                    e.target.classList.add(isActiveClass)
                    e.target.setAttribute('aria-selected', true)

                    /**
                     * Get the button tabid
                     */
                    let tabId = e.target.dataset.tabid

                    /**
                     * Loop throught all the tab panels
                     */
                    tabPanels.forEach((panel) => {
                        const panelId = panel.dataset.panelid

                        panel.classList.remove(isActiveClass)

                        /**
                         * If tab panel ID matches the tab button data-tabid:
                         * Show the tab
                         * Update the current tabPanel
                         */
                        if (tabId === panelId) {
                            current.tabPanel = panel
                            current.tabPanel.classList.add(isActiveClass)
                            current.tabPanel.focus()
                        }

                    })
                }
            })
        })

        /**
         * Locations Dropdown
         * @param {*} currentLocationsSelect
         * @param {*} isCurrentLocationsSelectOpen
         */
        const selectACarParkDropdown = (target) => {

            isCurrentLocationsSelectOpen = !isCurrentLocationsSelectOpen

            let currentLocationsDropdown = current.tabPanel.querySelector('.js-pb-locations-dropdown')

            if (isCurrentLocationsSelectOpen) {
                currentLocationsDropdown.classList.add(isActiveClass)
                currentLocationsSelect.setAttribute("data-is-open", true)
                /**
                 * Init dropdown navigation if the dropdown is active
                 */
                dropdownNav()
            } else {
                resetLocationsDropdown()
            }
        }

        /**
         * Dropdown Nav
         * This handles the Ui inside the drop down
         */
        const dropdownNav = () => {
            let locationButtons = [...current.tabPanel.querySelectorAll('.js-pb-location-btn')]

            locationButtons.forEach((btn) => {
                btn.addEventListener('click', () => {
                    let currentLocationItems = [...current.tabPanel.querySelectorAll('.js-pb-location-item')]

                    currentLocationItems.forEach((locationItem) => {
                        locationItem.classList.add(isActiveClass)
                    })

                    let locationIdHiddenInput = current.tabPanel.querySelector('.js-pb-location-id-input')
                    locationIdHiddenInput.setAttribute('value', btn.dataset.locationId)
                    // js-pb-location-id-input

                    let locationItem = btn.closest('.js-pb-location-item')

                    let locationCarparks = locationItem.nextElementSibling

                    locationCarparks.classList.add(isActiveClass)

                    addCarParkData(locationCarparks)

                })
            })

            dropdownNavBackButton()
        }
    

        /**
         * Add carpark data to locations input
         */
        const addCarParkData = (locationCarparks) => {


            const carParkButtons = [...locationCarparks.querySelectorAll('.js-pb-car-park')]

            carParkButtons.forEach(btn => {
                btn.addEventListener("click", (e) => {
    
                    const carParkData = e.target.closest("BUTTON").dataset.carpark
                    const carParkId = e.target.closest("BUTTON").dataset.carParkId

                    let carParkHiddenInput = current.tabPanel.querySelector('.js-pb-car-park-input')
                    carParkHiddenInput.setAttribute('value', carParkId)
                    
                    let locationsInput = current.tabPanel.querySelector('.js-pb-locations-input')
                    locationsInput.setAttribute('value', carParkData)
                    resetLocationsDropdown()
                })
            })
        }

        /**
         * Handle back button
         */
        const dropdownNavBackButton = () => {
            const backBtn = [...current.tabPanel.querySelectorAll('.js-pb-locations-back-btn')]

            backBtn.forEach((btn) => {
                btn.addEventListener('click', () => {
                    const allLocationItems = [...current.tabPanel.querySelectorAll('.js-pb-location-item')]

                    allLocationItems.forEach((locationItem) => {
                        locationItem.classList.remove(isActiveClass)
                    })

                    let activeCarParkItem = current.tabPanel.querySelector('.js-pb-car-park-item.is-active')
                    activeCarParkItem.classList.remove(isActiveClass)
                })
            })
        }

        /**
         * Reset Locations Dropdown
         */
        const resetLocationsDropdown = () => {

            /**
             * Reset Current Locations Dropdown
             */
            let currentLocationDropdown = current.tabPanel.querySelector(".js-pb-locations-dropdown")
            currentLocationDropdown.classList.remove(isActiveClass)

            /**
             * Reset Current Location Items
             */
            const currentLocationItems = [...current.tabPanel.querySelectorAll('.js-pb-location-item')]
            currentLocationItems.forEach((locationItem) => {
                if (locationItem.classList.contains(isActiveClass)) {
                    locationItem.classList.remove(isActiveClass)
                }
            })

            /**
             * Reset active Carpark Item
             */
            let activeCarParkItem = current.tabPanel.querySelector('.js-pb-car-park-item.is-active')
            if (activeCarParkItem) {
                activeCarParkItem.classList.remove(isActiveClass)
            }

            /**
             * Update the current select state to false
             * set the current select data att to false
             */
            isCurrentLocationsSelectOpen = false
            currentLocationsSelect = current.tabPanel.querySelector('.js-pb-locations-input')
            currentLocationsSelect.setAttribute("data-is-open", false)
        }

        /**
         * Prebooking Date pickers
         * Originally datepickers were initialised and setup inside a loop, however we needed to be able to re init the exit date picker with a min date set by 
         * the entry date picker. This was not possible using a loop & each datepicker is now initialised separately.
         * https://flatpickr.js.org/
         */

        const datePickerOptions = {
            minDate: 'today',
            enableTime: true,
            time_24hr: true,
            dateFormat: 'D d M Y H:i',
            hourIncrement: 1,
            minuteIncrement: 60,
            allowInput: false,
            disableMobile: true,
            "plugins": [new ConfirmDatePlugin({
                confirmText: "Done",
                showAlways: true,
                theme: "dark",
            })],
        }

        datePickerPrebookEntry.flatpickr({
            ...datePickerOptions,
            /**
             * When Flatpickr updates its input, format the date time instance
             * and set the inputs value in ISO format
             */
            onChange: (selectedDates, dateStr, instance) => {
                if (instance) {
                    let formattedDate = new Date(selectedDates)
                    formattedDate = formattedDate.toISOString()
                    datePickerPrebookEntry.setAttribute('value', formattedDate)

                    /**
                     * Re init exit date picker with updated minDate option
                     */
                    datePickerPrebookExit.flatpickr({
                        ...datePickerOptions,
                        minDate: formattedDate, 

                        onChange: (selectedDates, dateStr, instance) => {
                            if (instance) {
                                let formattedDate = new Date(selectedDates)
                                formattedDate = formattedDate.toISOString()
                                datePickerPrebookExit.setAttribute('value', formattedDate)
                            }
                        },   
                    })
                }
            },           
        })

        datePickerPrebookExit.flatpickr({
            ...datePickerOptions,

            onChange: (selectedDates, dateStr, instance) => {
                if (instance) {
                    let formattedDate = new Date(selectedDates)
                    formattedDate = formattedDate.toISOString()
                    datePickerPrebookExit.setAttribute('value', formattedDate)
                }
            },           
        })

        datePickerSeasonTicket.flatpickr({
            ...datePickerOptions,
            enableTime: false,
            dateFormat: 'D d M Y',

            onChange: (selectedDates, dateStr, instance) => {
                if (instance) {
                    let formattedDate = new Date(selectedDates)
                    formattedDate = formattedDate.toISOString()
                    datePickerSeasonTicket.setAttribute('value', formattedDate)
                }
            },           
        })

    }
}

export default prebookingDesktop
